import { AutogenModelBrokerageStatus, AutogenRowBrokerageStatus } from "./autogen/AutogenModelBrokerageStatus";

export class ModelBrokerageStatus extends AutogenModelBrokerageStatus<RowBrokerageStatus> {
    constructor() {
        super(RowBrokerageStatus);
    }
}

export class RowBrokerageStatus extends AutogenRowBrokerageStatus {
}